import { create } from 'zustand';

const initialShellState = {
  collapsed: false,
  currentPage: 'index',
};

const useShellStore = create((set) => ({
  ...initialShellState,

  setCollapsed: (collapsed) => set({ collapsed }),
  setCurrentPage: (currentPage) => set({ currentPage }),
}));

export default useShellStore;
